import { Pipe, PipeTransform } from '@angular/core';

export const convertToGeneralRelativeTime = (value: number, daysOnly = false): string => {
  // Today
  // Yesterday
  // This Week
  // Last Week
  // This Month
  // Older

  const ago = Date.now() - value;

  if (ago > 0) {
    const seconds = ago / 1000;
    if (seconds < 60 && !daysOnly) return 'Just now';

    const minutes = seconds / 60;
    const minutesFlat = Math.floor(minutes);
    if (minutes < 60 && !daysOnly) return `${minutesFlat} minute${minutesFlat === 1 ? '' : 's'} ago`;

    const hours = minutes / 60;
    const hoursFlat = Math.floor(hours);
    if (hours < 3 && !daysOnly) return `${hoursFlat} hour${hoursFlat === 1 ? '' : 's'} ago`;

    const today = new Date();
    const date = new Date(value);
    const isToday =
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();
    if (isToday) return `Today`;

    // check if the date is yesterday
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    const isYesterday =
      date.getDate() === yesterday.getDate() &&
      date.getMonth() === yesterday.getMonth() &&
      date.getFullYear() === yesterday.getFullYear();
    if (isYesterday) return `Yesterday`;

    // This week

    const startOfThisWeek = new Date(today);
    if (startOfThisWeek.getDay() !== 1) {
      // Only manipulate the date if it isn't Mon.
      startOfThisWeek.setHours(-24 * (startOfThisWeek.getDay() - 1));
    }
    startOfThisWeek.setHours(0, 0, 0, 0);

    if (value > startOfThisWeek.getTime()) return 'This week';

    // Last week

    const startOfLastWeek = new Date(startOfThisWeek);
    startOfLastWeek.setDate(startOfLastWeek.getDate() - 7);
    if (value > startOfLastWeek.getTime()) return 'Last week';

    // This month

    const startOfThisMonth = new Date(today);
    startOfThisMonth.setDate(1);
    startOfThisMonth.setHours(0, 0, 0, 0);

    if (value > startOfThisMonth.getTime()) return 'This month';

    // Older

    return 'Older';
  } else {
  }
};

export const convertToRelativeTime = (value: number, daysOnly = false): string => {
  const ago = Date.now() - value;

  // 1 second in the future, server events are rounded to the nearest second
  if (ago > -1000) {
    const seconds = ago / 1000;
    if (!daysOnly && seconds < 60) return 'Just now';

    const minutes = seconds / 60;
    const minutesFlat = Math.floor(minutes);
    if (!daysOnly && minutes < 60) return `${minutesFlat} minute${minutesFlat === 1 ? '' : 's'} ago`;

    const hours = minutes / 60;
    const hoursFlat = Math.floor(hours);
    if (!daysOnly && hours < 12) return `${hoursFlat} hour${hoursFlat === 1 ? '' : 's'} ago`;

    const today = new Date();
    const date = new Date(value);
    const isToday =
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();
    if (isToday) return `Today`;

    // check if the date is yesterday
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    const isYesterday =
      date.getDate() === yesterday.getDate() &&
      date.getMonth() === yesterday.getMonth() &&
      date.getFullYear() === yesterday.getFullYear();
    if (isYesterday) return `Yesterday`;

    if (!daysOnly && hours < 24) return `${hoursFlat} hour${hoursFlat === 1 ? '' : 's'} ago`;

    const days = hours / 24;
    const daysFlat = Math.floor(days);
    if (days < 7) return `${daysFlat} day${daysFlat === 1 ? '' : 's'} ago`;

    const weeks = days / 7;
    const weeksFlat = Math.floor(weeks);

    const months = days / 30;
    const monthsFlat = Math.floor(months);
    if (months < 1) return `${weeksFlat} week${weeksFlat === 1 ? '' : 's'} ago`;
    if (days < 365) return `${monthsFlat} month${monthsFlat === 1 ? '' : 's'} ago`;

    const years = days / 365;
    const yearsFlat = Math.floor(years);
    return `${yearsFlat} year${yearsFlat === 1 ? '' : 's'} ago`;
  } else {
    // TODO: from now

    console.warn('date is in the future', value, value - Date.now(), 'ms ago');

    return 'Just now';
  }
};

@Pipe({
  name: 'relativeTime',
  standalone: true,
})
export class RelativeTimePipe implements PipeTransform {
  transform(value: number, daysOnly = false): string {
    return convertToRelativeTime(value, daysOnly);
  }
}
